import logoImg from '@/assets/logo.png'

export const Header = () => {
  return (
    <header className="h-12 bg-[#dddddd] flex items-center px-4 border-b border-gray-500 select-none relative shadow-sm z-30">
      <div className="flex items-center gap-3 z-10">
        <img
          src={logoImg}
          alt="Banco da Sucata"
          className="h-8 w-auto object-contain filter drop-shadow-sm"
        />
      </div>

      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <h1 className="font-serif font-bold text-lg md:text-xl text-black retro-text-shadow tracking-wide">
          Página Inicial do Banco da Sucata
        </h1>
      </div>

      <div className="ml-auto flex gap-1.5">
        {/* Fake window controls */}
        <div className="w-4 h-4 border border-gray-600 bg-[#cccccc] shadow-inner"></div>
        <div className="w-4 h-4 border border-gray-600 bg-[#cccccc] shadow-inner"></div>
      </div>
    </header>
  )
}
